import styled from 'styled-components';
import { Translate } from 'react-redux-i18n';

import { getEditorScrollStyles } from '../../styles';
import { ButtonBack as BasicButtonBack } from '../styles';
import { NewStyleColor } from '../../../../utils/styles-constants';
import { hexToRgba } from '../../../../utils/style';

const StyledSelect = styled('div')`
	box-sizing: border-box;
	display: flex;
	align-items: center;
	height: 47px;
	padding: 0 10px;
`;

const Label = styled(Translate)`
	margin-right: auto;
	font-family: HelveticaNeue, sans-serif;
	font-size: 16px;
	line-height: 18px;
	color: ${hexToRgba(NewStyleColor.White, 75)};
`;

const ButtonValue = styled('button')`
	margin-left: 10px;
	padding: 0;
	border: 0;
	outline: 0;
	font-family: HelveticaNeue, sans-serif;
	font-size: 16px;
	color: ${NewStyleColor.White};
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	background-color: transparent;
	cursor: pointer;
`;

const ButtonIcon = styled('button')`
	display: flex;
	align-items: center;
	height: 10px;
	padding: 0;
	border: 0;
	outline: 0;
	background-color: transparent;
	cursor: pointer;

	svg {
		width: 10px;
		height: 10px;
		margin-left: 14px;
		fill: ${hexToRgba(NewStyleColor.White, 25)};
		transform: rotate(180deg);
	}
`;

const Color = styled('div')`
	box-sizing: border-box;
	width: 145px;
	height: 33px;
	border: 1px solid ${hexToRgba(NewStyleColor.White, 25)};
	border-radius: 9px;
`;

const Options = styled('div')`
	position: absolute;
	z-index: 2;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	padding: 15px 0;
	border-radius: 13px;
	background-color: ${NewStyleColor.Grey900};
`;

const OptionsHeader = styled('div')`
	position: relative;
	padding: 0 85px;
	font-family: HelveticaNeue, sans-serif;
	font-weight: 700;
	font-size: 17px;
	line-height: 16px;
	color: ${NewStyleColor.White};
	text-align: center;
`;

const OptionsListWrapper = styled('div')`
	box-sizing: border-box;
	height: calc(100% - 35px);
	margin-top: 20px;
	padding: 16px;
	overflow-y: auto;

	${getEditorScrollStyles({ width: 4 })}
`;

const OptionsList = styled('ul')`
	margin: 0;
	padding: 0;
	list-style-type: none;
`;

const OptionsListItem = styled('li')`
	background-color: ${hexToRgba(NewStyleColor.White, 10)};

	&:first-child {
		border-radius: 8px 8px 0 0;
	}

	&:last-child {
		border-radius: 0 0 8px 8px;
	}

	&:only-child {
		border-radius: 8px;
	}

	&:not(:first-child) {
		position: relative;

		&::after {
			content: '';
			position: absolute;
			top: 0;
			left: 15px;
			right: 0;
			height: 1px;
			background-color: ${hexToRgba(NewStyleColor.White, 30)};
		}
	}

	&:hover {
		background-color: ${hexToRgba(NewStyleColor.White, 25)};

		&::after {
			background-color: transparent;
		}
	}

	&:hover + &::after {
		background-color: transparent;
	}
`;

const ButtonOption = styled('button')`
	position: relative;
	height: 44px;
	width: 100%;
	padding: 0 20px 0 50px;
	border: 0;
	outline: 0;
	background-color: transparent;
	font-size: 15px;
	line-height: 44px;
	color: ${hexToRgba(NewStyleColor.White, 75)};
	text-align: left;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	cursor: pointer;

	> svg {
		position: absolute;
		top: 14px;
		left: 20px;
		width: 17px;
		height: 15px;
		fill: ${NewStyleColor.Blue450};
	}
`;

const ButtonBack = styled(BasicButtonBack)`
	position: absolute;
	top: 0;
	left: 15px;
`;

const ListTypeOption = styled('div')`
	display: flex;
	align-items: center;
	justify-content: space-between;

	svg {
		width: 28px;
		height: 28px;
		fill: currentColor;
	}
`;

export {
	StyledSelect,
	Label,
	ButtonValue,
	ButtonIcon,
	Color,
	Options,
	OptionsHeader,
	OptionsListWrapper,
	OptionsList,
	OptionsListItem,
	ButtonOption,
	ButtonBack,
	ListTypeOption,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/Select/styles.ts